import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import UserService from "../controllers/UserService";
import AuthService from "../controllers/AuthService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import FriendshipGame from "../components/Game/FriendshipGame";
import $ from 'jquery';

class ReportEvaluateStudentList extends React.Component {
    constructor(props) {
        super(props);
        this.changeData = this.changeData.bind(this);
        this.state = {
            user: AuthService.getCurrentUser(),
            role: AuthService.getUserRole(),
            modalShowEndActivity: false,
            // name: 'นายวัศพล คนไทย',
            id: '1234',
            // text1: 'ยังไม่ได้ประเมิน',
            // text2: 'ยังไม่ได้ประเมินคุณครู',
            // text3: 'ยังประเมินเพื่อนไม่ครบ (2/3)',
            status_text1: 'waiting',
            status_text2: 'done',
            status_text3: 'inprogress',
            students: [],
            currentStudentIdClick: null,
            roomId: props.roomId, //'60c0e14221965c37a7c1b75f'
            statusFriends: 0,
            statusTeacher: 0,
            statusSelf: 0,
            modalShow: false,
            roomyear: '',
            roomterm: '',
            roomgrade: '',
            roomgradeyear: ''
        };

    }

    componentDidMount() {
        UserService.getFriendshipReportList(this.state.roomId).then(
            (res) => {

                var allStudents = [];
                var count = 0;
                for (const [index, value] of res.data.data.entries()) {

                    if (value.user.roles[0].toLowerCase() !== 'teacher') {

                        var status = [];
                        var statusOverview = 0;
                        var statusFriends = 0; //-0 not yet, 1-inprogress, 2 done
                        var statusTeacher = 0;
                        var statusSelf = 0;
                        var teacherDone = 0;

                        for (const [i, v] of value.targets.entries()) {

                            if (v.answerAt !== null) {
                                status.push(true);
                                statusOverview++;
                                if (value.user.id === v.user.id) {
                                    statusSelf++;
                                }
                                else if (v.user.roles[0].toLowerCase() !== 'teacher') {
                                    statusFriends++;
                                } else if (v.user.roles[0].toLowerCase() === 'teacher') {
                                    statusTeacher++;
                                }

                            } else {
                                status.push(false);
                            }

                        }

                        for (const [ii, vv] of value.others.entries()) {
                            if (vv.answerAt !== null && vv.user.roles[0].toLowerCase() === 'teacher') {
                                teacherDone++;
                            }
                        }

                        allStudents[count] = {
                            'name': value.user.fullName,
                            'id': value.user.id,
                            'status': status,
                            'statusOverview': statusOverview,
                            'statusFriends': statusFriends,
                            'statusTeacher': statusTeacher,
                            'statusSelf': statusSelf,
                            'teacherDone': teacherDone,
                            'classTeacherDone': teacherDone > 0 ? 't-done' : 't-notdone',
                            'no': value.user.no
                        }

                        count++;

                    } else {

                    }
                }

                allStudents.sort(function (a, b) { return a['no'] - b['no']; });

                this.setState({ students: allStudents });
            });

        UserService.getRoomDetail(this.state.roomId).then((response) => {
            this.setState({ roomyear: response.data.data.year });
            this.setState({ roomterm: response.data.data.term });
            this.setState({ roomgrade: response.data.data.grade });
            this.setState({ roomgradeyear: response.data.data.gradeYear });
        });

    }

    changeData(id, name) {
        this.props.referenceCallback(id, name);
    }

    selectionChange() {
        var e = document.getElementById("selection-evaluate");
        var selectValue = e.value;
        var temp = $('#search').val();
        var count1 = 1;
        if (!selectValue) { selectValue = 'all' }

        $('.div-detail').each(function (i, obj) {
            let studentName = obj.querySelector('.student-name').innerHTML + obj.querySelector('.student-no').innerHTML;
            let isDone = obj.classList.contains('t-done')
            var checkStatus = studentName.includes(temp);

            if (
                (checkStatus && selectValue === 'done' && isDone) ||
                (checkStatus && selectValue === 'notdone' && !isDone) ||
                (checkStatus && selectValue === 'all')
            ) {
                $(obj).show();
                // obj.querySelector('.order').innerHTML = count1;
                // count1++;
            } else {
                $(obj).hide();
            }
        });
    }


    render() {
        return (
            <div >

                <div className="px-4 main-detail">
                    <Row className="px-0" >

                        <Col xs={12} className="w-100 pb-3 px-0">
                            <Col className="w-100 px-0" id="search-div">
                                <FontAwesomeIcon icon={faSearch} className="gray-text3 icon-search"></FontAwesomeIcon>
                                <input className="form-control form-control-sm w-100 border-radius-5 search" type="text" id="search" placeholder="ค้นหา ชื่อ-นามสกุล หรือเลขที่ ..." onInput={() => this.selectionChange()} />
                            </Col>
                        </Col>

                    </Row>
                    <Row>
                        <img src="/images/friendship-game/banner_friendship.jpg" className="click-pointer w-100 d-none d-lg-block" onClick={() => { this.setState({ modalShow: true }) }}></img>
                        <img src="/images/friendship-game/banner_friendship_mobile.jpg" className="click-pointer w-100 d-lg-none" onClick={() => { this.setState({ modalShow: true }) }}></img>
                    </Row>
                    <Row className="blue-bg py-2 mt-3">
                        <Col xs={2} md={2} className="text-center pr-0 gray-text3">เลขที่</Col>
                        <Col xs={6} md={7} className="text-center gray-text3">ชื่อ - นามสกุล</Col>
                        <Col xs={4} md={3} className="r-status">
                            <select id="selection-evaluate" class="form-control form-control-sm border-radius-5 w-100 my-4 font-sarabun" className="selection-evaluate gray-text3" onChange={() => { this.selectionChange() }} style={{ "fontSize": "13px" }}>
                                <option value="" selected disabled hidden>สถานะของครู</option>
                                <option value="all">ทั้งหมด</option>
                                <option value="done">ประเมินแล้ว</option>
                                <option value="notdone">ยังไม่ประเมิน</option>
                            </select>
                        </Col>
                    </Row>
                    {
                        (this.state.students.length > 0) ? (
                            this.state.students.map((item, index) => (
                                <Row key={index.toString()} className={`border-bottom-blue py-3 div-detail ${item.classTeacherDone}`}>
                                    <Col xs={2} md={2} className="text-center my-1"><h5 className="mb-0 font-weight-600 order student-no">{index + 1}</h5></Col>
                                    <Col xs={6} md={7} className="text-left my-1">
                                        <Row>
                                            <Col xs={12} md={12} className="text-left my-1">
                                                <h5 className="mb-0 font-weight-600 mb-1 student-name">{item.name}</h5>
                                                <h6 className="text-green-evaluate font-weight-600 click-pointer" onClick={() => { this.changeData(item.id, item.name) }}><u>รายละเอียด</u></h6>
                                            </Col>
                                        </Row>

                                    </Col>

                                    <Col xs={4} md={3} className="text-right my-1 d-flex">
                                        <Button className="bluesky d-inline py-1 py-md-2 px-3 px-md-5  font-sarabun-bold btn btn-primary export-btn" href={`/report/friendship/export/all/${this.state.roomId}/${item.id}`} target="_blank"><h5 className="mb-0 font-weight-bold">Export</h5></Button>
                                    </Col>
                                </Row>
                            ))
                        ) : (
                            <div></div>
                        )
                    }
                </div>
                <Modal
                    show={this.state.modalShow}
                    onHide={() => { this.setState({ modalShow: false }) }}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="alert-modal"
                >
                    <Modal.Body className="font-sarabun text-center pt-1">
                        <p className="text-right m-0"><img src='/images/evaluate/x.png' className="click-pointer" onClick={() => { this.setState({ modalShow: false }) }} /></p>
                        <Row className="evaluate-modal-friendship">
                            {(this.state.roomyear && this.state.roomterm && this.state.roomgrade && this.state.roomgradeyear) ? <FriendshipGame year={this.state.roomyear} term={this.state.roomterm} grade={this.state.roomgrade} gradeYear={this.state.roomgradeyear} showFilterGradeYear={false} showHeader={false} /> : null}
                        </Row>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

export default ReportEvaluateStudentList
